module.exports = __webpack_public_path__ + "img/step32_a_printer_power_open_endcap - Copy.1f4ec321.png";